import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { OPERATORS, type MarketingTags as MarketingTagsType } from 'typings'
import { Tag } from 'ui'
import { messages } from './messages'

type Props = {
  marketingTags: MarketingTagsType
}

export function MarketingTags(props: Props) {
  const { marketingTags } = props

  const { formatList, $t } = useIntl()

  if (!marketingTags) return null

  const { operator, tags } = marketingTags

  const processTooltip = () => {
    switch (operator) {
      case OPERATORS.EQUALS:
        return formatList(tags)
      case OPERATORS.DIFFERENT:
        return $t(messages.marketingTags.isDifferent, {
          tags: formatList(tags),
        })
    }
  }

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.marketingTags.title} />
      </Tag>
    </Tooltip>
  )
}
